const dev = "https://dev.tellipsis.com";
const staging = "https://portal.get8net.com";
const tellipsis = "https://portal.tellipsis.com";
const domain = window.location.host;



export const api ={
    dev:tellipsis,
}

export const usersGroupRolesList = [
    {
        id: 2,
        role: 'Admin',
        description: 'Admin',
        isActive: true
    },
    {
        id: 3,
        role: 'Reseller',
        description: 'Reseller',
        isActive: true
    },
    {
        id: 4,
        role: 'User',
        description: 'User',
        isActive: true
    }

]

